export default "__VITE_ASSET__Cpqkqbni__"